import gql from 'graphql-tag'

export default (filters) => gql`
  {
    commerceProductQuery (
      # @see: https://github.com/drupal-graphql/graphql/blob/8.x-3.x/doc/queries/filters.md
      filter: {
        conditions: [
          ${filters.filter.conditions.field.langcode}
          ${filters.filter.conditions.field.status}
          ${filters.filter.conditions.field.title}
          ${filters.filter.conditions.field.category}
          ${filters.filter.conditions.field.field_filter_narzedzia}
          ${filters.filter.conditions.field.field_filter_role_zawodowe}
          # {field: "field_category.entity.name", operator: IN, value: ${JSON.stringify(filters.category)}}
          # {field: "field_category.entity.name", operator: IN, value: ["Badania kompetencji", "Egzaminy"]}
          # {field: "field_category.entity.name", operator: IN, value: [${filters.category}]}
          # {field: "field_category.entity.name", operator: IN, value: ${filters.category}}
          # {field: "field_category.entity.name", value: ["${filters.category}"], operator: EQUAL}
          # {field: "field_category.entity.name", value: "Badania kompetencji", operator: EQUAL}
        ]
      }

      sort: ${filters.sort}
      # sort: {field: "title", direction: ASC}
      # sort: {field: "title", direction: DESC}
      # sort: {field: "created", direction: DESC}

      # limit: 99999999 # default is 10, how to set unlimited items?!
      limit: ${filters.limit} # this is something like perPage

      offset: ${filters.offset}
    ) 
    {
      count
      entities {
        __typename
        # entityId
        entityBundle
      
        ... on CommerceProductDefault {

          # id
          # drupal_id
          # drupal_internal__nid
          drupal_internal__product_id: entityId
          # internal {
          #     type
          # }

          langcode {
            value
          }
          title
          path {
              pid
              alias
              langcode
          }
          body {
              summary
          }
          created

          # variations {
          #     ... on commerce_product_variation__default {
          #         variationId: drupal_internal__variation_id
          #         sku
          #         title
          #         price {
          #             number
          #             currencyCode: currency_code
          #         }
          #         relationships {
          #             bundle: __typename
          #             field_images {
          #                 localFile {
          #                     childImageSharp {
          #                         fluid(maxWidth: 255) {
          #                             ...GatsbyImageSharpFluid
          #                         }
          #                     }
          #                 }
          #             }
          #         }
          #     }
          # }

          variations {
            entity {
              # entityBundle
              variationId
              sku
              title
              price {
                number
                currencyCode
                formatted
              }
              resolvedPrice {
                number
                currencyCode
                formatted
              }
              calculatedPrice {
                number
                currencyCode
                formatted
              }
              # entityRendered # this contains what would Drupal render, the benefit of this field it behaves the same way as Twig frontend!
              
              ... on CommerceProductVariationDefault {

                field_images: fieldImages {
                  entity {
                    entityUuid
                  }

                  # derivative(style: MAX650X650) {
                  derivative(style: MAX325X325) {
                    url
                    width
                    height
                  }
                }

                attribute_size: attributeSize {
                  entity {
                    ... on CommerceProductAttributeValueSize {
                      entityId
                      entityLabel
                      weight
                    }
                  }
                }

              }

            }
          }

          # field_menu_item: fieldMenuItem {
          #   entity {
          #     title
          #   }
          # }

          field_category: fieldCategory {
              entity {
                  ... on TaxonomyTermKategorieSklep {
                      name
                  }
              }
          }

          # fieldRelatedProducts {
          #   entity {
          #     ... on CommerceProductDefault {
          #         # ...ProductRelated # ???
          #     }
          #   }
          # }

          # commerce_product_variation__default {
          # 	sku
          #     price {
          #         number
          #         currency_code
          #     }
          #     ... on commerce_product_variation__default {
          #     }
          # }

        }
      }
    }
  }  
`